import { render, staticRenderFns } from "./FormRelacion.vue?vue&type=template&id=72485811&scoped=true"
import script from "./FormRelacion.vue?vue&type=script&lang=js"
export * from "./FormRelacion.vue?vue&type=script&lang=js"
import style0 from "./FormRelacion.vue?vue&type=style&index=0&id=72485811&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72485811",
  null
  
)

export default component.exports